
import React from "react";
import Widget from "../../../../components/Widget/Widget";
import FormIncapacidades from "../FormIncapacidades";
import { createIncapacity } from "../functions";

export const CrearIncapacidad = (props) => {

  return (
    <Widget className="widget-p-md">
        <h3>Crear tipo de incapacidad</h3>
        <FormIncapacidades crear={createIncapacity}/>
    </Widget>
  )
}

export default CrearIncapacidad;